"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundAndAddTaxAmounts = exports.computeTotalAndRounds = exports.addTaxAmounts = exports.buildTaxBreakdownsFromItems = exports.parseTaxBreakdowns = exports.roundItemsConsistently = exports.sumNotRoundedItemsByKey = exports.sumRoundedItemsByKey = exports.roundByCumulativeMethodWithTotal = exports.roundByCumulativeMethod = exports.roundItemsNormally = exports.roundItemValues = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var big_numbers_1 = require("../../utils/big-numbers");
var roundItemValues = function (item) {
    var itemRounded = {};
    Object.keys(item).forEach(function (key) {
        itemRounded[key] = item[key].integerValue(bignumber_js_1.default.ROUND_HALF_UP).toNumber();
    });
    return itemRounded;
};
exports.roundItemValues = roundItemValues;
var roundItemsNormally = function (items) {
    var itemsRounded = [];
    items.forEach(function (item) {
        itemsRounded.push((0, exports.roundItemValues)(item));
    });
    return itemsRounded;
};
exports.roundItemsNormally = roundItemsNormally;
var roundByCumulativeMethod = function (items) {
    var itemsRounded = [];
    if (items.length) {
        Object.keys(items[0]).forEach(function (key) {
            var cumulativeReal = big_numbers_1.big0;
            var cumulativeRounded = big_numbers_1.big0;
            for (var i = 0; i < items.length; i++) {
                if (!itemsRounded[i])
                    itemsRounded[i] = {};
                cumulativeReal = cumulativeReal.plus(items[i][key]);
                var newValue = bignumber_js_1.default.maximum(cumulativeReal.minus(cumulativeRounded), 0);
                itemsRounded[i][key] = newValue.integerValue(bignumber_js_1.default.ROUND_HALF_UP).toNumber();
                cumulativeRounded = cumulativeRounded.plus(itemsRounded[i][key]);
            }
        });
    }
    return itemsRounded;
};
exports.roundByCumulativeMethod = roundByCumulativeMethod;
var roundByCumulativeMethodWithTotal = function (items, totalExact, totalNotExact) {
    var itemsRounded = [];
    if (items.length) {
        Object.keys(items[0]).forEach(function (key) {
            var cumulativeReal = big_numbers_1.big0;
            var cumulativeRounded = big_numbers_1.big0;
            var differenceToDistribute = totalExact[key] - totalNotExact[key];
            for (var i = 0; i < items.length; i++) {
                if (!itemsRounded[i])
                    itemsRounded[i] = {};
                cumulativeReal = cumulativeReal.plus(items[i][key]);
                var newAmount = cumulativeReal
                    .minus(cumulativeRounded)
                    .absoluteValue()
                    .integerValue(bignumber_js_1.default.ROUND_HALF_UP)
                    .toNumber();
                if (differenceToDistribute) {
                    if (differenceToDistribute > 0) {
                        newAmount += differenceToDistribute;
                    }
                    else if (newAmount > Math.abs(differenceToDistribute)) {
                        newAmount -= Math.abs(differenceToDistribute);
                    }
                    else {
                        newAmount = 0;
                        differenceToDistribute += newAmount;
                    }
                }
                itemsRounded[i][key] = newAmount;
                cumulativeRounded = cumulativeRounded.plus(itemsRounded[i][key]);
            }
        });
    }
    return itemsRounded;
};
exports.roundByCumulativeMethodWithTotal = roundByCumulativeMethodWithTotal;
var sumRoundedItemsByKey = function (items) {
    var sumObject = {};
    if (items.length) {
        Object.keys(items[0]).forEach(function (key) {
            sumObject[key] = items.reduce(function (accumulator, object) { return accumulator + object[key]; }, 0);
        });
    }
    return sumObject;
};
exports.sumRoundedItemsByKey = sumRoundedItemsByKey;
var sumNotRoundedItemsByKey = function (items) {
    var sumObject = {};
    if (items.length) {
        Object.keys(items[0]).forEach(function (key) {
            sumObject[key] = items.reduce(function (accumulator, object) { return accumulator.plus(object[key]); }, big_numbers_1.big0);
        });
    }
    return sumObject;
};
exports.sumNotRoundedItemsByKey = sumNotRoundedItemsByKey;
var roundItemsConsistently = function (items, total) {
    /* This method allows to round elements properly, while keeping sum(elements) === total
    Example : if you distribute 10 candies to 3 children, each one should receive 3,33... candies.
    If you round normally, you would say that each child actually received 3 candies, which means that only 9 candies were distributed !
    To avoid that, we round by "cumulative method", which represents 3 candies to 1st child, 4 candies to 2nd child, and 3 to 3rd child.
    Why is that ? Because the cumulative number of candies is 3,33 for 1st child (which rounds to 3), then it is 6,67 for 2nd child (which rounds to 7, so 7-3=4 candies for 2nd child), then 10 for 3rd child (which rounds to 10, so 10-7=3 candies for 3rd child) */
    var itemsRoundedNormally = (0, exports.roundItemsNormally)(items);
    var sumItemsNormally = (0, exports.sumRoundedItemsByKey)(itemsRoundedNormally); // round first, then sum. It does not always equal the true total
    var itemsRoundedByCumulativeMethod = (0, exports.roundByCumulativeMethod)(items);
    total = total || (0, exports.roundItemValues)((0, exports.sumNotRoundedItemsByKey)(items)); // sum first, then round : this is the true total
    var sumItemsCumulative = (0, exports.sumRoundedItemsByKey)(itemsRoundedByCumulativeMethod);
    var itemsRoundedByCumulativeMethodWithTotal = (0, exports.roundByCumulativeMethodWithTotal)(items, total, sumItemsCumulative);
    var finalItems = [];
    Object.keys(total).forEach(function (key) {
        if (sumItemsNormally[key] === total[key]) {
            // the consistency sum === total is respected, so we can round normally
            for (var i = 0; i < items.length; i++) {
                if (!finalItems[i])
                    finalItems[i] = {};
                finalItems[i][key] = itemsRoundedNormally[i][key];
            }
        }
        else if (sumItemsCumulative[key] === total[key]) {
            // the consistency sum === total is NOT respected, so we need to round with cumulative method
            for (var i = 0; i < items.length; i++) {
                if (!finalItems[i])
                    finalItems[i] = {};
                finalItems[i][key] = itemsRoundedByCumulativeMethod[i][key];
            }
        }
        else {
            // the consistency sum === total is NOT respected, and the total is different from cumulativeMethod, so we need to round with cumulative method + use total
            for (var i = 0; i < items.length; i++) {
                if (!finalItems[i])
                    finalItems[i] = {};
                finalItems[i][key] = itemsRoundedByCumulativeMethodWithTotal[i][key];
            }
        }
    });
    return { items: finalItems, total: total };
};
exports.roundItemsConsistently = roundItemsConsistently;
var parseTaxBreakdowns = function (taxBreakdowns) {
    var totalPrices = [];
    var taxRates = [];
    taxBreakdowns.forEach(function (taxBreakdown) {
        totalPrices.push(taxBreakdown.totalPrice);
        taxRates.push(taxBreakdown.taxRate);
    });
    return { taxRates: taxRates, totalPrices: totalPrices };
};
exports.parseTaxBreakdowns = parseTaxBreakdowns;
var buildTaxBreakdownsFromItems = function (taxRates, totalPrices) {
    var taxBreakdownsRounded = [];
    for (var i = 0; i < taxRates.length; i++) {
        taxBreakdownsRounded.push({
            taxRate: taxRates[i],
            totalPrice: totalPrices[i],
        });
    }
    return taxBreakdownsRounded;
};
exports.buildTaxBreakdownsFromItems = buildTaxBreakdownsFromItems;
var addTaxAmounts = function (totalPrice) { return (__assign(__assign({}, totalPrice), { totalTax: totalPrice.totalInclTax - totalPrice.totalExclTax, totalTaxWithDiscount: totalPrice.totalInclTaxWithDiscount - totalPrice.totalExclTaxWithDiscount, totalTaxWithRemise: totalPrice.totalInclTaxWithRemise - totalPrice.totalExclTaxWithRemise })); };
exports.addTaxAmounts = addTaxAmounts;
var computeTotalAndRounds = function (taxBreakdowns, totalAlreadyComputed) {
    var _a = (0, exports.parseTaxBreakdowns)(taxBreakdowns), taxRates = _a.taxRates, totalPrices = _a.totalPrices;
    var _b = totalAlreadyComputed
        ? (0, exports.roundItemsConsistently)(totalPrices, totalAlreadyComputed)
        : (0, exports.roundItemsConsistently)(totalPrices), totalPricesRoundedPartial = _b.items, totalComputed = _b.total;
    var totalPartial = totalAlreadyComputed || totalComputed;
    var totalPricesRounded = totalPricesRoundedPartial.map(function (totalPrice) {
        return (0, exports.addTaxAmounts)(totalPrice);
    });
    var total = (0, exports.addTaxAmounts)(totalPartial);
    var taxBreakdownsRounded = (0, exports.buildTaxBreakdownsFromItems)(taxRates, totalPricesRounded);
    return { taxBreakdowns: taxBreakdownsRounded, priceBreakdown: total };
};
exports.computeTotalAndRounds = computeTotalAndRounds;
var roundAndAddTaxAmounts = function (itemsToRound, itemsSum) {
    var prices = itemsToRound.map(function (item) { return item.totalPriceNotRounded; });
    var pricesRoundedPartial = (0, exports.roundItemsConsistently)(prices, itemsSum).items;
    for (var i = 0; i < pricesRoundedPartial.length; i++) {
        itemsToRound[i].totalPriceRounded = (0, exports.addTaxAmounts)(pricesRoundedPartial[i]);
    }
};
exports.roundAndAddTaxAmounts = roundAndAddTaxAmounts;
